import textComponent from '@/components/backoffice/type/text'
import localComponent from '@/components/backoffice/type/url/local'
import hrefComponent from '@/components/backoffice/type/url/href'
import booleanComponent from '@/components/backoffice/type/boolean'
import numberComponent from '@/components/backoffice/type/number'
import imageComponent from '@/components/backoffice/type/image'
import categoryComponent from '@/components/backoffice/type/category'
import roleComponent from '@/components/backoffice/type/role'
import phoneNumberComponent from '@/components/backoffice/type/phoneNumber'
import dateComponent from '@/components/backoffice/type/date'
import dateWithDayComponent from '@/components/backoffice/type/dateWithDay'
import dateTimeComponent from '@/components/backoffice/type/datetime'
import fullNameComponent from '@/components/backoffice/type/fullName'
import currencyComponent from '@/components/backoffice/type/currency'
import companyCfComponent from '@/components/backoffice/type/companycf'
import statusComponent from '@/components/backoffice/type/status.vue'
import hiddenTextComponent from '@/components/backoffice/type/hidden.vue'

export default {
  text: getConfigurableProps(textComponent),
  longText: getConfigurableProps(textComponent),
  phoneNumber: getConfigurableProps(phoneNumberComponent),
  date: getConfigurableProps(dateComponent),
  dateWithDay: getConfigurableProps(dateWithDayComponent),
  dateTime: getConfigurableProps(dateTimeComponent),
  fullName: getConfigurableProps(fullNameComponent),
  object: getConfigurableProps(localComponent),
  url: getConfigurableProps(hrefComponent),
  email: getConfigurableProps(hrefComponent),
  boolean: getConfigurableProps(booleanComponent),
  number: getConfigurableProps(numberComponent),
  image: getConfigurableProps(imageComponent),
  category: getConfigurableProps(categoryComponent),
  role: getConfigurableProps(roleComponent),
  currency: getConfigurableProps(currencyComponent),
  companyCf: getConfigurableProps(companyCfComponent),
  hidden: getConfigurableProps(hiddenTextComponent),
  status: getConfigurableProps(statusComponent)
}

function getConfigurableProps (component) {
  let ret = []

  let props = component.props

  for (let prop in props) {
    if (props.hasOwnProperty(prop)) {
      if (props[prop].configurable) {
        ret.push(prop)
      }
    }
  }

  return ret
}
